module.exports = __webpack_public_path__ + "img/cone_pt_slt_setsku.prt.d287b6a3.jpg";